import { createTheme, ThemeProvider } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import Login from "./components/website/Login";
import SignUp from "./components/setup/SignUp";
import Dashbaord from "./components/setup/Dashbaord";
import ProtectedRoute from "./components/setup/ProtectedRoute";
// Admin Management
import Tills from "./components/AdminManagement/Tills";
import DailyOpening from "./components/AdminManagement/DailyOpening";
import DailyClosing from "./components/AdminManagement/DailyClosing";
import SetUserRights from "./components/AdminManagement/SetUserRIghts";
import CreateUser from "./components/AdminManagement/CreateUser";
import LoginHistoryReport from "./components/AdminManagement/LoginHistoryReport";
import UserBranchAssignments from "./components/AdminManagement/UserBranchAssignments";
import SingleDataScreen from "./components/AdminManagement/SingleDataScreen";
import RecipeListing from "./components/AdminManagement/RecipeListing";
import Recipe from "./components/AdminManagement/Recipe";
import ProductionFormulas from "./components/AdminManagement/ProductionFormulas";
import ProductionBatches from "./components/AdminManagement/ProductionBatches";
import StockLedger from "./components/AdminManagement/StockLedger";
import ManualIssuance from "./components/AdminManagement/ManualIssuance";
import Branches from "./components/AdminManagement/Branches/BranchesListing";
import AddNewBranch from "./components/AdminManagement/Branches/AddNewBranch";
import AuditList from "./components/AdminManagement/Audit/AuditListing";
import Audit from "./components/AdminManagement/Audit/Audit";
import OpeningStockEntry from "./components/AdminManagement/Audit/OpeningStockEntry";
import PrinterAssignment from "./components/setup/PrinterAssignment";
import BulkPrinterIPAssignment from "./components/setup/BulkPrinterIPAssignment";
import ESP32DeviceManagement from "./components/setup/ESP32DeviceManagement";
import KitchenManagement from "./components/setup/KitchenManagement";
import CategoryKitchenMapping from "./components/setup/CategoryKitchenMapping";
import DispatchCounterManagement from "./components/setup/DispatchCounterManagement";
import TakeawayCounterManagement from "./components/setup/TakeawayCounterManagement";
import DineInTableManagement from "./components/setup/DineInTableManagement";
import DineInTokenManagement from "./components/setup/DineInTokenManagement";
import CashCountersManagement from "./components/setup/CashCountersManagement";
import DealsManagement from "./components/setup/DealsManagement";
import PromoCodesManagement from "./components/setup/PromoCodesManagement";
import PrintBehaviorSettings from "./components/setup/PrintBehaviorSettings";
import PrintTemplateDesigner from "./components/setup/PrintTemplateDesigner";
import POSOrderTypeSettings from "./components/setup/POSOrderTypeSettings";
import OrderTakerManagement from "./components/setup/OrderTakerManagement";
import EmployeeManagement from "./components/setup/EmployeeManagement";
import PaperSizeManagement from "./components/setup/PaperSizeManagement";
import CustomerAppThemeSettings from "./components/setup/CustomerAppThemeSettings";
import WebAppThemeSettings from "./components/setup/WebAppThemeSettings";
import AccountsManagement from "./components/setup/AccountsManagement";
import TaxIntegrationSandbox from "./components/setup/TaxIntegrationSandbox";
import LinkedBillingIdentities from "./components/setup/LinkedBillingIdentities";

// General Management Components
import PartiesInformation from "./components/GeneralManagement/PartiesInformation";
import ItemCategory from "./components/GeneralManagement/ItemCategory";
import ItemHeads from "./components/GeneralManagement/ItemHeads";
import ItemCom from "./components/GeneralManagement/ItemCompany";

// Stock Management Components
import ItemsInformation from "./components/StockManagement/ItemsInformation";
import CounterSale from "./components/StockManagement/CounterSale";
// import RestSales from "./components/StockManagement/RestSales";
import PurchaseRequestList from "./components/StockManagement/Purchases/PurchaseRequestList";
import AddPurchaseRequest from "./components/StockManagement/Purchases/AddPurchaseRequest";
import PurchaseOrderList from "./components/StockManagement/Purchases/PurchaseOrderList";
import AddPurchaseOrder from "./components/StockManagement/Purchases/AddPurchaseOrder";
import PurchaseDeliveryList from "./components/StockManagement/Purchases/PurchaseDeliveryList";
import AddPurchaseDelivery from "./components/StockManagement/Purchases/AddPurchaseDelivery";
import PurchaseInvoice from "./components/StockManagement/Purchases/PurchaseInvoice";
import PurchaseWorkflowSettings from "./components/setup/PurchaseWorkflowSettings";
import PurchaseWorkflowGuard from "./components/StockManagement/Purchases/PurchaseWorkflowGuard";
import AddPurchaseInvoice from "./components/StockManagement/Purchases/AddPurchaseInvoice";
import POS from './components/StockManagement/POS'
import POSProfileRouter from './components/StockManagement/POSProfileRouter'
import BakeryPOS from './components/StockManagement/Bakery/BakeryPOS'
import BakeryForwardInvoice from './components/StockManagement/Bakery/BakeryForwardInvoice'
import BakeryCashCounter from './components/StockManagement/Bakery/BakeryCashCounter'
import PublicInvoiceVerification from './components/StockManagement/PublicInvoiceVerification'
import DeliveryDashboard from './components/StockManagement/DeliveryDashboard'
import DineTakeawayDashboard from './components/StockManagement/DineTakeawayDashboard'
import KitchenOrderScreen from './components/StockManagement/KitchenOrderScreen'
import ItemsQuickUpdate from './components/StockManagement/ItemsQuickUpdate'
import OrderCancellation from './components/StockManagement/OrderCancellation'

// Stock Reports Components
import SalesDashbaord from "./components/StockReports/SalesDashboard";
import SalesReport from "./components/StockReports/SalesReport";
import DeliveryTimelineReport from "./components/StockReports/DeliveryTimelineReport";
import SalesByTypeReport from "./components/StockReports/SalesByTypeReport";
import ItemWiseSalesReport from "./components/StockReports/ItemWiseSalesReport";
import ItemChangesAuditReport from "./components/StockReports/ItemChangesAuditReport";
import KOTPrintLogReport from "./components/StockReports/KOTPrintLogReport";
import PurchaseReport from "./components/StockReports/PurchaseReport";
import ClosingReport from "./components/AccountsReports/ClosingReport";
import RestartServices from "./components/AdminManagement/RestartServices";
import CurrentStock from "./components/StockReports/CurrentStock";
import InventoryDashboard from "./components/StockReports/InventoryDashboard";
import WaitlistAnnouncementMonitor from "./components/setup/WaitlistAnnouncementMonitor";
import "./services/GlobalVariables";
import { DEFAULT_WEB_THEME, applyWebThemeVariables, normalizeWebTheme } from "./utils/webThemeSettings";

const buildTheme = (webTheme) => createTheme({
  palette: {
    primary: {
      main: webTheme.primaryColor || '#780202'
    },
    secondary: {
      main: webTheme.cardBgColor || '#ffffff',
    },
    custom: {
      main: webTheme.cardBgColor || "#ffffff"
    }
  },
  typography: {
    fontFamily: webTheme.fontFamily || 'Helvetica',
  },
  shape: {
    borderRadius: Number(webTheme.borderRadius) || 4,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: webTheme.pageBgColor || '#F6F7FB',
          fontFamily: webTheme.fontFamily || 'Helvetica',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: webTheme.buttonColor || '#780202',
          color: webTheme.buttonTextColor || '#FFFFFF',
        },
      },
    },
  },
})

const DEFAULT_APP_TITLE = "Lucky Broast";

const PAGE_TITLES = {
  "/Login": "Login",
  "/POS": "Point of Sale",
  "/RestaurantPOS": "Restaurant Point of Sale",
  "/BakeryPOS": "Bakery Point of Sale",
  "/BakeryForwardInvoice": "Bakery Forward Invoice",
  "/BakeryCashCounter": "Bakery Cash Counter",
  "/DeliveryDashboard": "Delivery Dashboard",
  "/DineTakeawayDashboard": "Takeaway & Dispatch Order Tracking",
  "/TakeawayDispatchTracking": "Takeaway Counter Order Tracking",
  "/DineInOrderTracking": "Dine-In Order Tracking",
  "/OrderCancellation": "Order Cancellation",
  "/SalesDashbaord": "Sales Dashboard",
  "/SalesReport": "Sales Report",
  "/LoginHistoryReport": "Login History Report",
  "/DeliveryTimelineReport": "Delivery Timeline Report",
  "/SalesByType": "Sales by Type",
  "/ItemWiseSalesReport": "Item Wise Sales Report",
  "/CurrentStock": "Current Stock",
  "/InventoryDashboard": "Inventory Dashboard",
  "/ItemChangesAudit": "Item Changes Audit",
  "/KOTPrintLogReport": "KOT Print Log Report",
  "/PurchaseReport": "Purchase Report",
  "/ClosingReport": "Closing Report",
  "/DailyOpening": "Daily Opening",
  "/DailyClosing": "Daily Closing",
  "/PurchaseRequest": "Purchase Request",
  "/AddPurchaseRequest": "Add Purchase Request",
  "/PurchaseOrder": "Purchase Order",
  "/AddPurchaseOrder": "Add Purchase Order",
  "/PurchaseInvoice": "Purchase Invoice",
  "/AddPurchaseInvoice": "Add Purchase Invoice",
  "/GRN": "GRN",
  "/AddGRN": "Add GRN",
  "/ItemsInformation": "Items Information",
  "/ItemsQuickUpdate": "Items Quick Update",
  "/CounterSale": "Counter Sale",
  "/CustomerAppTheme": "Customer App Theme",
  "/WebAppTheme": "Web App Theme",
  "/POSOrderTypeSettings": "POS Order Type Settings",
  "/OrderTakers": "Order Takers",
  "/Employees": "Employees",
  "/DashBaord": "Dashboard",
};

const getPageTitle = (pathname) => {
  if (PAGE_TITLES[pathname]) {
    return PAGE_TITLES[pathname];
  }

  const lastPathSegment = pathname.split("/").filter(Boolean).pop();
  if (!lastPathSegment) {
    return "Point of Sale";
  }

  return lastPathSegment
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/-/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
};

function PageTitleUpdater({ companyName }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const appTitle = companyName || DEFAULT_APP_TITLE;
    const pageTitle = getPageTitle(pathname);
    const title = pageTitle ? `${pageTitle} | ${appTitle}` : appTitle;
    const description = `${appTitle} ${pageTitle} management screen`;

    document.title = title;

    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
      descriptionTag.setAttribute("content", description);
    }
  }, [companyName, pathname]);

  return null;
}
function App() {
  const user = useSelector((state) => state.auth.user);
  const companyName = user?.cmpName || user?.company?.cmpName || DEFAULT_APP_TITLE;
  const cmpID = user?.cmpID || user?.company?.cmpID || 1;
  const [webTheme, setWebTheme] = useState(DEFAULT_WEB_THEME);
  const theme = useMemo(() => buildTheme(webTheme), [webTheme]);

  useEffect(() => {
    let isMounted = true;

    const loadWebTheme = async () => {
      try {
        const response = await axios.get(`${global.SET_API_URL}webTheme/public`, { params: { cmpID } });
        if (!isMounted) return;
        const nextTheme = normalizeWebTheme(response?.data?.data || DEFAULT_WEB_THEME);
        setWebTheme(nextTheme);
        applyWebThemeVariables(nextTheme);
      } catch (error) {
        if (!isMounted) return;
        setWebTheme(DEFAULT_WEB_THEME);
        applyWebThemeVariables(DEFAULT_WEB_THEME);
      }
    };

    loadWebTheme();

    const handleThemeUpdated = () => loadWebTheme();
    window.addEventListener("webThemeSettingsUpdated", handleThemeUpdated);

    return () => {
      isMounted = false;
      window.removeEventListener("webThemeSettingsUpdated", handleThemeUpdated);
    };
  }, [cmpID]);

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
                <PageTitleUpdater companyName={companyName} />
        <WaitlistAnnouncementMonitor />
        <Routes>

          {/* <Route exact path="/" element={<FeedbackForm />} /> */}


          <Route path="/Login" element={<Login />} />
          <Route path="/FirstSetup" element={<SignUp />} />
          <Route path="/verify-invoice/:token" element={<PublicInvoiceVerification />} />

          {/* Account Reports */}
          <Route path="/ClosingReport" element={<ProtectedRoute><ClosingReport /></ProtectedRoute>} />

          {/* Admin Management */}
          <Route path="/Tills" element={<ProtectedRoute><Tills /></ProtectedRoute>} />
          <Route path="/DailyOpening" element={<ProtectedRoute><DailyOpening /></ProtectedRoute>} />
          <Route path="/SetUserRights" element={<ProtectedRoute><SetUserRights /></ProtectedRoute>} />
          <Route path="/CreateUser" element={<ProtectedRoute><CreateUser /></ProtectedRoute>} />
          <Route path="/LoginHistoryReport" element={<ProtectedRoute><LoginHistoryReport /></ProtectedRoute>} />
          <Route path="/UserBranchAssignments" element={<ProtectedRoute><UserBranchAssignments /></ProtectedRoute>} />
          <Route path="/DailyClosing" element={<ProtectedRoute><DailyClosing /></ProtectedRoute>} />
          <Route path="/RestartServices" element={<ProtectedRoute><RestartServices /></ProtectedRoute>} />
          <Route path="/Recipe" element={<ProtectedRoute><RecipeListing /></ProtectedRoute>} />
          <Route path="/AddRecipe" element={<ProtectedRoute><Recipe /></ProtectedRoute>} />
          <Route path="/ProductionFormulas" element={<ProtectedRoute><ProductionFormulas /></ProtectedRoute>} />
          <Route path="/ProductionBatches" element={<ProtectedRoute><ProductionBatches /></ProtectedRoute>} />
          <Route path="/StockLedger" element={<ProtectedRoute><StockLedger /></ProtectedRoute>} />
          <Route path="/ManualIssuance" element={<ProtectedRoute><ManualIssuance /></ProtectedRoute>} />
          <Route path="/AuditListing" element={<ProtectedRoute><AuditList /></ProtectedRoute>} />
          <Route path="/InvAudit" element={<ProtectedRoute><Audit /></ProtectedRoute>} />
          <Route path="/AuditOpeningStock" element={<ProtectedRoute><OpeningStockEntry /></ProtectedRoute>} />
          <Route path="/Branches" element={<ProtectedRoute><Branches /></ProtectedRoute>} />
          <Route path="/AddBranch" element={<ProtectedRoute><AddNewBranch /></ProtectedRoute>} />
          <Route path="/PrinterAssignment" element={<ProtectedRoute><PrinterAssignment /></ProtectedRoute>} />
          <Route path="/BulkPrinterIPAssignment" element={<ProtectedRoute><BulkPrinterIPAssignment /></ProtectedRoute>} />
          <Route path="/ESP32DeviceManagement" element={<ProtectedRoute><ESP32DeviceManagement /></ProtectedRoute>} />
          <Route path="/Kitchens" element={<ProtectedRoute><KitchenManagement /></ProtectedRoute>} />
          <Route path="/CategoryKitchenMapping" element={<ProtectedRoute><CategoryKitchenMapping /></ProtectedRoute>} />
          <Route path="/DispatchCounters" element={<ProtectedRoute><DispatchCounterManagement /></ProtectedRoute>} />
          <Route path="/TakeawayCounters" element={<ProtectedRoute><TakeawayCounterManagement /></ProtectedRoute>} />
          <Route path="/DineInTables" element={<ProtectedRoute><DineInTableManagement /></ProtectedRoute>} />
          <Route path="/DineInTokens" element={<ProtectedRoute><DineInTokenManagement /></ProtectedRoute>} />
          <Route path="/CashCounters" element={<ProtectedRoute><CashCountersManagement /></ProtectedRoute>} />
          <Route path="/Deals" element={<ProtectedRoute><DealsManagement /></ProtectedRoute>} />
          <Route path="/PromoCodes" element={<ProtectedRoute><PromoCodesManagement /></ProtectedRoute>} />
          <Route path="/PrintBehaviorSettings" element={<ProtectedRoute><PrintBehaviorSettings /></ProtectedRoute>} />
          <Route path="/PrintTemplateDesigner" element={<ProtectedRoute><PrintTemplateDesigner /></ProtectedRoute>} />
          <Route path="/POSOrderTypeSettings" element={<ProtectedRoute><POSOrderTypeSettings /></ProtectedRoute>} />
          <Route path="/OrderTakers" element={<ProtectedRoute><OrderTakerManagement /></ProtectedRoute>} />
          <Route path="/Employees" element={<ProtectedRoute><EmployeeManagement /></ProtectedRoute>} />
          <Route path="/PaperSizeManagement" element={<ProtectedRoute><PaperSizeManagement /></ProtectedRoute>} />
          <Route path="/CustomerAppTheme" element={<ProtectedRoute><CustomerAppThemeSettings /></ProtectedRoute>} />
          <Route path="/WebAppTheme" element={<ProtectedRoute><WebAppThemeSettings /></ProtectedRoute>} />
          <Route path="/Accounts" element={<ProtectedRoute><AccountsManagement /></ProtectedRoute>} />
          <Route path="/TaxIntegrationSandbox" element={<ProtectedRoute><TaxIntegrationSandbox /></ProtectedRoute>} />
          <Route path="/LinkedBillingIdentities" element={<ProtectedRoute><LinkedBillingIdentities /></ProtectedRoute>} />

          {/* General Management Routes */}
          <Route exact path="/" element={<Navigate to="/POS" replace />} />
          <Route path="/PartiesInformation" element={<ProtectedRoute><PartiesInformation /></ProtectedRoute>} />
          <Route path="/ItemCategory" element={<ProtectedRoute><ItemCategory /></ProtectedRoute>} />
          <Route path="/ItemHeads" element={<ProtectedRoute><ItemHeads /></ProtectedRoute>} />
          <Route path="/itemCompany" element={<ProtectedRoute><ItemCom /></ProtectedRoute>} />
          <Route path="/UnitofMeasurement" element={<ProtectedRoute><SingleDataScreen /></ProtectedRoute>} />
          <Route path="/Departments" element={<ProtectedRoute><SingleDataScreen /></ProtectedRoute>} />
          <Route path="/VariantSetup" element={<ProtectedRoute><SingleDataScreen /></ProtectedRoute>} />

          {/* Stock Management Routes */}
          <Route path="/ItemsInformation" element={<ProtectedRoute><ItemsInformation /></ProtectedRoute>} />
          <Route path="/ItemsQuickUpdate" element={<ProtectedRoute><ItemsQuickUpdate /></ProtectedRoute>} />
          <Route path="/CounterSale" element={<ProtectedRoute><CounterSale /></ProtectedRoute>} />
          {/* <Route path="/Sales" element={<RestSales />} /> */}
          <Route path="/PurchaseRequest" element={<ProtectedRoute><PurchaseWorkflowGuard stage="PR"><PurchaseRequestList /></PurchaseWorkflowGuard></ProtectedRoute>} />
          <Route path="/AddPurchaseRequest" element={<ProtectedRoute><PurchaseWorkflowGuard stage="PR"><AddPurchaseRequest /></PurchaseWorkflowGuard></ProtectedRoute>} />
          <Route path="/PurchaseOrder" element={<ProtectedRoute><PurchaseWorkflowGuard stage="PO"><PurchaseOrderList /></PurchaseWorkflowGuard></ProtectedRoute>} />
          <Route path="/AddPurchaseOrder" element={<ProtectedRoute><PurchaseWorkflowGuard stage="PO"><AddPurchaseOrder /></PurchaseWorkflowGuard></ProtectedRoute>} />
          <Route path="/GRN" element={<ProtectedRoute><PurchaseWorkflowGuard stage="PD"><PurchaseDeliveryList /></PurchaseWorkflowGuard></ProtectedRoute>} />
          <Route path="/AddGRN" element={<ProtectedRoute><PurchaseWorkflowGuard stage="PD"><AddPurchaseDelivery /></PurchaseWorkflowGuard></ProtectedRoute>} />
          <Route path="/PurchaseInvoice" element={<ProtectedRoute><PurchaseWorkflowGuard stage="PI"><PurchaseInvoice /></PurchaseWorkflowGuard></ProtectedRoute>} />
          <Route path="/PurchaseWorkflowSettings" element={<ProtectedRoute><PurchaseWorkflowSettings /></ProtectedRoute>} />
          <Route path="/AddPurchaseInvoice" element={<ProtectedRoute><PurchaseWorkflowGuard stage="PI"><AddPurchaseInvoice /></PurchaseWorkflowGuard></ProtectedRoute>} />
          <Route path="/POS" element={<ProtectedRoute><POSProfileRouter /></ProtectedRoute>} />
          <Route path="/RestaurantPOS" element={<ProtectedRoute><POS /></ProtectedRoute>} />
          <Route path="/BakeryPOS" element={<ProtectedRoute><BakeryPOS /></ProtectedRoute>} />
          <Route path="/BakeryForwardInvoice" element={<ProtectedRoute><BakeryForwardInvoice /></ProtectedRoute>} />
          <Route path="/BakeryCashCounter" element={<ProtectedRoute><BakeryCashCounter /></ProtectedRoute>} />
          <Route path="/OrderCancellation" element={<ProtectedRoute><OrderCancellation /></ProtectedRoute>} />
          <Route path="/DeliveryDashboard" element={<ProtectedRoute><DeliveryDashboard /></ProtectedRoute>} />
          <Route path="/DineTakeawayDashboard" element={<ProtectedRoute><DineTakeawayDashboard /></ProtectedRoute>} />
          <Route path="/TakeawayDispatchTracking" element={<ProtectedRoute><DineTakeawayDashboard mode="takeaway" /></ProtectedRoute>} />
          <Route path="/DineInOrderTracking" element={<ProtectedRoute><DineTakeawayDashboard mode="dinein" /></ProtectedRoute>} />
          <Route path="/KitchenOrderScreen" element={<ProtectedRoute><KitchenOrderScreen /></ProtectedRoute>} />


          {/* Stock Reports */}
          <Route path="/SalesDashbaord" element={<ProtectedRoute><SalesDashbaord /></ProtectedRoute>} />
          <Route path="/SalesReport" element={<ProtectedRoute><SalesReport /></ProtectedRoute>} />
          <Route path="/DeliveryTimelineReport" element={<ProtectedRoute><DeliveryTimelineReport /></ProtectedRoute>} />
          <Route path="/SalesByType" element={<ProtectedRoute><SalesByTypeReport /></ProtectedRoute>} />
          <Route path="/ItemWiseSalesReport" element={<ProtectedRoute><ItemWiseSalesReport /></ProtectedRoute>} />
          <Route path="/CurrentStock" element={<ProtectedRoute><CurrentStock /></ProtectedRoute>} />
          <Route path="/InventoryDashboard" element={<ProtectedRoute><InventoryDashboard /></ProtectedRoute>} />
          <Route path="/ItemChangesAudit" element={<ProtectedRoute><ItemChangesAuditReport /></ProtectedRoute>} />
          <Route path="/KOTPrintLogReport" element={<ProtectedRoute><KOTPrintLogReport /></ProtectedRoute>} />
          <Route path="/PurchaseReport" element={<ProtectedRoute><PurchaseReport /></ProtectedRoute>} />

          {/* <Route path="/ResAppbar" element={<ResAppBar />} /> */}
          <Route path="/DashBaord" element={<ProtectedRoute><Dashbaord /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to={user ? "/POS" : "/Login"} replace />} />

        </Routes>
      </BrowserRouter>
    </ThemeProvider>

  );
}

export default App;






